import React from "react";
import { Menu } from "antd";
import {
  UsergroupAddOutlined,
  TeamOutlined,
  CrownOutlined,
  SearchOutlined,
  UserSwitchOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import { keycloakAuthenticated, userTokenHasRole } from "../../selectors";

const GroupActionsMenu = ({ authenticated, isExternal }) => {
  const location = useLocation();

  // Determine selected menu key based on current path
  const getSelectedKey = () => {
    const path = location.pathname;
    if (path === "/") return "search-groups";
    if (path.startsWith("/groups/admin")) return "all-groups";
    if (path.startsWith("/group/memberships/my")) return "my-groups";
    if (path.startsWith("/groups/membership-search"))
      return "membership-search";
    if (path === "/group/create") return "create-static-group";
    if (path === "/group/createDynamic") return "create-dynamic-group";
    return "";
  };

  const menuItems = [
    {
      key: "search-groups",
      label: (
        <NavLink
          className={({ isActive }) => (isActive ? "active" : "")}
          to="/"
        >
          <SearchOutlined style={{ color: "#bfbfbf" }} />
          <span>Groups search</span>
        </NavLink>
      ),
    },
    !isExternal && {
      key: "all-groups",
      label: (
        <NavLink
          className={({ isActive }) => (isActive ? "active" : "")}
          to="/groups/admin"
        >
          <CrownOutlined style={{ color: "#bfbfbf" }} />
          <span>Groups I own or manage</span>
        </NavLink>
      ),
    },
    {
      key: "my-groups",
      label: (
        <NavLink
          className={({ isActive }) => (isActive ? "active" : "")}
          to="/group/memberships/my"
        >
          <TeamOutlined style={{ color: "#bfbfbf" }} />
          <span>Groups I'm in</span>
        </NavLink>
      ),
    },
    !isExternal && {
      key: "create-static-group",
      label: (
        <NavLink
          className={({ isActive }) => (isActive ? "active" : "")}
          to="/group/create"
        >
          <UsergroupAddOutlined style={{ color: "#bfbfbf" }} />
          <span>Create new static group</span>
        </NavLink>
      ),
    },
    !isExternal && {
      key: "create-dynamic-group",
      label: (
        <NavLink
          className={({ isActive }) => (isActive ? "active" : "")}
          to="/group/createDynamic"
        >
          <UserSwitchOutlined style={{ color: "#bfbfbf" }} />
          <span>Create new dynamic group</span>
        </NavLink>
      ),
    },
    !isExternal && {
      key: "membership-search",
      label: (
        <NavLink
          className={({ isActive }) => (isActive ? "active" : "")}
          to="/groups/membership-search"
        >
          <UserOutlined style={{ color: "#bfbfbf" }} />
          <span>Membership search</span>
        </NavLink>
      ),
    },
  ];
  return (
    <>
      {authenticated && (
        <div>
          <Menu
            mode="horizontal"
            items={menuItems}
            selectedKeys={[getSelectedKey()]}
          />
        </div>
      )}
    </>
  );
};

export default connect((state) => ({
  authenticated: keycloakAuthenticated(state),
  isExternal: !userTokenHasRole(state, "group_reader"),
}))(GroupActionsMenu);
